import { render, staticRenderFns } from "./OrderDeliveredDashboard.vue?vue&type=template&id=6947b18b&scoped=true&"
import script from "./OrderDeliveredDashboard.vue?vue&type=script&lang=js&"
export * from "./OrderDeliveredDashboard.vue?vue&type=script&lang=js&"
import style0 from "./OrderDeliveredDashboard.vue?vue&type=style&index=0&id=6947b18b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6947b18b",
  null
  
)

export default component.exports